(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
    (function() {
  
      var elsH = document.querySelectorAll(".image-spliter .mover");
      var i = elsH.length;
      while (i--) {
          var moverWidth = elsH[i].getBoundingClientRect().width;
          var imgLeft = elsH[i].nextElementSibling;
          var width = imgLeft.getBoundingClientRect().width;
          var height = imgLeft.getBoundingClientRect().height;
          elsH[i].style.left = width / 2 - moverWidth / 2 + 'px';
          //imgLeft.style.clip = "rect(0px, " + width / 2 + "px, " + height + "px, 0px)";
          imgLeft.style.clip = "rect(0px, " + width / 2 + "px, 999px, 0px)";
          var mouseDownX = 0;
          var X;
          elsH[i].addEventListener("mousedown", function(e) {
              X = e.clientX;
              mouseDownX = 1;
          });
          elsH[i].addEventListener("mouseup", function(e) {
              mouseDownX = 0;
          });
          elsH[i].addEventListener("mouseout", function(e) {
              mouseDownX = 0;
          });
  
          elsH[i].addEventListener("touchstart", function(e) {
              X = e.touches[0].clientX;
              mouseDownX = 1;
          });
          elsH[i].addEventListener("touchend", function(e) {
              mouseDownX = 0;
          });
  
          elsH[i].addEventListener("mousemove", function(e) {
              if (mouseDownX) {
                  this.style.left = parseInt(this.style.left) + (event.clientX - X) + "px";
                  X = event.clientX;
                  this.nextElementSibling.style.clip = "rect(0px, " + (this.getBoundingClientRect().width / 2 + parseInt(this.style.left)) + "px, " + this.getBoundingClientRect().height + "px, 0px)";
              }
          });
  
          elsH[i].addEventListener("touchmove", function(e) {
              if (mouseDownX) {
                  this.style.left = parseInt(this.style.left) + (e.touches[0].clientX - X) + "px";
                  X = e.touches[0].clientX;
                  this.nextElementSibling.style.clip = "rect(0px, " + (this.getBoundingClientRect().width / 2 + parseInt(this.style.left)) + "px, " + this.getBoundingClientRect().height + "px, 0px)";
              }
          });
  
      }
  
  
      window.addEventListener("resize", function(f) {
          var elsHre = document.querySelectorAll(".image-spliter .mover");
          var ii = elsHre.length;
          while (ii--) {
              var moverWidth = elsHre[ii].getBoundingClientRect().width;
              var imgLeft = elsHre[ii].nextElementSibling;
              var width = imgLeft.getBoundingClientRect().width;
              var height = imgLeft.getBoundingClientRect().height;
              elsHre[ii].style.left = width / 2 - moverWidth / 2 + 'px';
              imgLeft.style.clip = "rect(0px, " + width / 2 + "px, " + height + "px, 0px)";
          }
      });
  
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dg-cart"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('submit',async function(event){
  const form=event.target.closest('[data-dg-cart-form]');
  if(!form||event.submitter?.name!=='update')return;
  event.preventDefault();const button=event.submitter,error=form.querySelector('[data-dg-cart-error]');button.disabled=true;error.hidden=true;
  try{const response=await fetch(form.dataset.updateUrl,{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});const result=await response.json();if(!response.ok)throw new Error(result.description||result.message||'Unable to update the cart. Please try again.');window.location.href=form.querySelector('[name="return_to"]').value;}
  catch(e){error.textContent=e.message;error.hidden=false;button.disabled=false;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dg-main"] && !Shopify.designMode) return;
  try {
    
// Supply the sticky-header offset to the theme's existing anchor handler.
document.addEventListener('click',function(event){
  const link=event.target.closest('.dg-experience a[href^="#"]');
  if(!link)return;
  const styles=getComputedStyle(document.documentElement);
  const sticky=styles.getPropertyValue('--header-is-sticky').trim()==='1';
  const height=sticky?(parseFloat(styles.getPropertyValue('--header-height'))||0):0;
  link.setAttribute('data-offset',String(Math.ceil(height)+20));
},true);
function dgCalculate(lengths) {
  if (!lengths.length || lengths.length > 20) throw new Error('length');
  const runs = lengths.map(value => {
    const str = String(value).trim();
    if (!/^\d+(?:\.\d{1,3})?$/.test(str)) throw new Error('length');
    const metres = Number(str);
    if (!Number.isFinite(metres) || metres <= 0 || metres > 1000) throw new Error('length');
    return Math.ceil(Math.round(metres * 1000) / 1250);
  });
  const strips = runs.reduce((a,b) => a+b, 0), packs = Math.ceil(strips / 12);
  return {strips, packs, metres:packs*15, spares:packs*12-strips, runs};
}
function dgOrderSummary(input) {
  const q=Number(input.value), summary=input.closest('[data-dg-experience]').querySelector('[data-dg-order-summary]');
  if(summary && Number.isInteger(q) && q>0){summary.textContent=q+(q===1?' pack':' packs')+' · '+q*12+' strips · '+q*15+' m supplied';const total=input.closest('[data-dg-experience]').querySelector('[data-dg-order-total]');if(total)total.textContent=new Intl.NumberFormat('en-AU',{style:'currency',currency:input.dataset.currency||'AUD'}).format(q*Number(input.dataset.price)/100)+' '+(input.dataset.currency||'AUD');}
}
document.addEventListener('click',function(event) {
  const experience=event.target.closest('[data-dg-experience]');if(!experience)return;
  if(event.target.closest('[data-dg-qty-minus],[data-dg-qty-plus]')){const input=experience.querySelector('[data-dg-order-quantity]');const delta=event.target.closest('[data-dg-qty-plus]')?1:-1;input.value=Math.max(1,Math.min(999,(Number(input.value)||1)+delta));dgOrderSummary(input);return;}
  if(event.target.closest('[data-dg-print]')) { window.print(); return; }
  const thumb=event.target.closest('[data-dg-thumbnail]');
  if(thumb) {
    const gallery=thumb.closest('[data-dg-gallery]'), hero=gallery.querySelector('.dg-product-main-image');
    hero.src=thumb.dataset.src;hero.removeAttribute('srcset');hero.alt=thumb.dataset.alt;
    gallery.querySelectorAll('[data-dg-thumbnail]').forEach(el=>el.setAttribute('aria-pressed',String(el===thumb)));return;
  }
  const root=event.target.closest('[data-dg-calculator]');if(!root)return;
  const error=root.querySelector('[data-dg-error]'),result=root.querySelector('[data-dg-result]'),rows=root.querySelector('[data-dg-runs]');
  function reset(){error.hidden=true;result.hidden=true;}
  function renumber(){rows.querySelectorAll('.dg-calc-row').forEach((row,i)=>{row.querySelector('label').textContent=root.dataset.runLabel+' '+(i+1)+' (m)';row.querySelector('button').hidden=rows.children.length===1;row.querySelector('button').setAttribute('aria-label',root.dataset.removeLabel+' '+(i+1));});}
  if(event.target.closest('[data-dg-add]')) {
    reset();if(rows.children.length>=20){error.textContent=root.dataset.limit;error.hidden=false;return;}
    const row=rows.firstElementChild.cloneNode(true),input=row.querySelector('input');input.value='';
    input.id='dg-run-'+Date.now()+'-'+rows.children.length;row.querySelector('label').htmlFor=input.id;
    rows.append(row);renumber();input.focus();
  } else if(event.target.closest('[data-dg-remove]')) {
    event.target.closest('.dg-calc-row').remove();reset();renumber();rows.querySelector('input').focus();
  } else if(event.target.closest('[data-dg-calculate]')) {
    reset();try {
      const lengths=Array.from(rows.querySelectorAll('input')).map(el=>el.value),out=dgCalculate(lengths);
      result.replaceChildren();
      const title=document.createElement('strong');title.textContent=out.packs+' '+(out.packs===1?root.dataset.singlePackLabel:root.dataset.packLabel);
      const detail=document.createElement('p');detail.textContent=out.strips+' '+(out.strips===1?root.dataset.singleStripLabel:root.dataset.stripLabel);
      const supplied=document.createElement('p');supplied.textContent=root.dataset.suppliedLabel+': '+out.packs*12+' '+root.dataset.stripsLabel+' ('+out.metres+' m)';
      const spare=document.createElement('p');spare.textContent=root.dataset.spareTitle+': '+out.spares;
      const breakdown=document.createElement('ul');out.runs.forEach((n,i)=>{const li=document.createElement('li');li.textContent=root.dataset.runLabel+' '+(i+1)+': '+lengths[i]+' m → '+n+' '+(n===1?root.dataset.singleStripLabel:root.dataset.stripLabel);breakdown.append(li);});
      const note=document.createElement('p');note.textContent=root.dataset.resultNote;
      result.append(title,detail,supplied,spare,breakdown,note);
      if(root.dataset.shopUrl){const shop=document.createElement('a');shop.className='button button--secondary dg-button';shop.href=root.dataset.shopUrl;shop.textContent=root.dataset.shopLabel;result.append(shop);}
      const quantity=experience.querySelector('[data-dg-order-quantity]');
      if(quantity){const apply=document.createElement('button');apply.type='button';apply.className='button button--secondary dg-button';apply.textContent=root.dataset.applyLabel;apply.addEventListener('click',()=>{quantity.value=out.packs;dgOrderSummary(quantity);quantity.focus();quantity.scrollIntoView({block:'center'});});result.append(apply);}
      const link=document.createElement('a');link.className='button button--secondary dg-button dg-enquire';link.textContent=root.dataset.requestLabel;
      const url=new URL(root.dataset.quoteUrl,window.location.origin);url.searchParams.set('runs',lengths.join(','));link.href=url.toString();result.append(link);result.hidden=false;
    } catch(e){error.textContent=root.dataset.invalid;error.hidden=false;}
  }
});
document.addEventListener('input',function(event){const root=event.target.closest('[data-dg-calculator]');if(root){root.querySelector('[data-dg-result]').hidden=true;root.querySelector('[data-dg-error]').hidden=true;}if(event.target.matches('[data-dg-order-quantity]'))dgOrderSummary(event.target);});
function dgFillMeasuredPlan(){const input=document.querySelector('[data-dg-quote-runs]'),runs=new URLSearchParams(window.location.search).get('runs');if(input&&runs){try{const values=runs.split(','),out=dgCalculate(values);input.value=values.map((v,i)=>'Run '+(i+1)+': '+v+' m').join('\n')+'\nEstimate: '+out.strips+' strips; '+out.packs+' packs; '+out.metres+' m supplied; '+out.spares+' spare strips. Each section is rounded up to a whole strip.';}catch(e){}}}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',dgFillMeasuredPlan);else dgFillMeasuredPlan();
document.addEventListener('shopify:section:load',dgFillMeasuredPlan);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp-gallery-grid"] && !Shopify.designMode) return;
  try {
    
(function(){function initGallery(section){if(!section||section.dataset.dpgInitialized==='true')return;var dialog=section.querySelector('[data-dpg-lightbox]'),triggers=Array.prototype.slice.call(section.querySelectorAll('[data-dpg-open]'));if(!dialog||!triggers.length)return;section.dataset.dpgInitialized='true';var imgEl=dialog.querySelector('[data-dpg-img]'),capEl=dialog.querySelector('[data-dpg-caption]'),ctaEl=dialog.querySelector('[data-dpg-cta]'),current=0,items=[];triggers.forEach(function(trigger){var full=trigger.getAttribute('data-full');if(!full)return;var index=items.length;items.push({full:full,caption:trigger.getAttribute('data-caption')||'',alt:trigger.getAttribute('data-alt')||trigger.getAttribute('data-caption')||'',link:trigger.getAttribute('data-link')||'',buttonLabel:trigger.getAttribute('data-button-label')||'View Product'});trigger.addEventListener('click',function(){open(index)})});if(!items.length)return;function show(index){current=(index+items.length)%items.length;var item=items[current];imgEl.src=item.full;imgEl.alt=item.alt;capEl.textContent=item.caption;if(item.link){ctaEl.href=item.link;ctaEl.textContent=item.buttonLabel||'View Product';ctaEl.hidden=false}else{ctaEl.hidden=true;ctaEl.removeAttribute('href')}}function open(index){show(index);if(typeof dialog.showModal==='function'){if(!dialog.open)dialog.showModal()}else dialog.setAttribute('open','')}function close(){if(typeof dialog.close==='function'&&dialog.open)dialog.close();else dialog.removeAttribute('open')}dialog.querySelector('[data-dpg-close]').addEventListener('click',close);dialog.querySelector('[data-dpg-prev]').addEventListener('click',function(){show(current-1)});dialog.querySelector('[data-dpg-next]').addEventListener('click',function(){show(current+1)});dialog.addEventListener('click',function(event){if(event.target===dialog)close()});dialog.addEventListener('keydown',function(event){if(event.key==='ArrowLeft'){event.preventDefault();show(current-1)}if(event.key==='ArrowRight'){event.preventDefault();show(current+1)}});var touchX=null;dialog.addEventListener('touchstart',function(event){touchX=event.changedTouches[0].clientX},{passive:true});dialog.addEventListener('touchend',function(event){if(touchX===null)return;var dx=event.changedTouches[0].clientX-touchX;if(Math.abs(dx)>40)show(current+(dx<0?1:-1));touchX=null},{passive:true})}function initAll(root){(root||document).querySelectorAll('[data-dp-gallery]').forEach(initGallery)}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll(document)});else initAll(document);document.addEventListener('shopify:section:load',function(event){initAll(event.target)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp-install-guide"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest ? e.target.closest('.dp-install__facade') : null;
  if (!btn) return;
  var iframe = document.createElement('iframe');
  iframe.src = btn.getAttribute('data-yt-src');
  iframe.setAttribute('allowfullscreen', '');
  iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
  iframe.setAttribute('title', 'Designer Plants installation video');
  btn.parentNode.replaceChild(iframe, btn);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp-related-categories-pre-retry-cleanup-26-aug"] && !Shopify.designMode) return;
  try {
    
(function () {
  var DESKTOP = 1024;

  // '.layout__section--secondary' is this theme's collection sidebar. Without it the
  // lookup failed silently, the block never moved, and it rendered full width above
  // the breadcrumb. The remaining selectors are fallbacks for other themes.
  var SIDEBAR_SELECTORS = [
    '.layout__section--secondary',
    '.collection__sidebar',
    '.collection-sidebar',
    '.sidebar--collection',
    '[class*="collection__sidebar"]',
    '.collection__aside',
    'aside.sidebar'
  ];

  var FIRST_FILTER_SELECTORS = [
    '.collection__filter-group',
    '.sidebar__section',
    '.sidebar__block',
    '.filter-group',
    'details'
  ];

  function findSidebar() {
    for (var i = 0; i < SIDEBAR_SELECTORS.length; i++) {
      var el = document.querySelector(SIDEBAR_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function findFirstFilter(sidebar) {
    for (var i = 0; i < FIRST_FILTER_SELECTORS.length; i++) {
      var el = sidebar.querySelector(FIRST_FILTER_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function place() {
    var block = document.querySelector('[data-dp-relcat]');
    if (!block) return;
    if (block.getAttribute('data-dp-relcat-move') !== 'true') return;

    if (window.innerWidth < DESKTOP) {
      if (block.classList.contains('is-in-sidebar') && block.dpHome) {
        block.dpHome.appendChild(block);
        block.classList.remove('is-in-sidebar');
      }
      return;
    }

    if (block.classList.contains('is-in-sidebar')) return;

    var sidebar = findSidebar();
    if (!sidebar) return;

    if (!block.dpHome) block.dpHome = block.parentNode;

    var firstFilter = findFirstFilter(sidebar);
    if (firstFilter && firstFilter.parentNode) {
      firstFilter.parentNode.insertBefore(block, firstFilter);
    } else {
      sidebar.insertBefore(block, sidebar.firstChild);
    }
    block.classList.add('is-in-sidebar');
  }

  function boot() {
    place();
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      place();
      if (tries > 12) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(place, 200);
  });

  document.addEventListener('shopify:section:load', place);
  document.addEventListener('collection:reloaded', place);
  document.addEventListener('filter:updated', place);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp-related-categories"] && !Shopify.designMode) return;
  try {
    
(function () {
  var DESKTOP = 1024;

  // '.layout__section--secondary' is this theme's collection sidebar. Without it the
  // lookup failed silently, the block never moved, and it rendered full width above
  // the breadcrumb. The remaining selectors are fallbacks for other themes.
  var SIDEBAR_SELECTORS = [
    '.layout__section--secondary',
    '.collection__sidebar',
    '.collection-sidebar',
    '.sidebar--collection',
    '[class*="collection__sidebar"]',
    '.collection__aside',
    'aside.sidebar'
  ];

  var FIRST_FILTER_SELECTORS = [
    '.collection__filter-group',
    '.sidebar__section',
    '.sidebar__block',
    '.filter-group',
    'details'
  ];

  function findSidebar() {
    for (var i = 0; i < SIDEBAR_SELECTORS.length; i++) {
      var el = document.querySelector(SIDEBAR_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function findFirstFilter(sidebar) {
    for (var i = 0; i < FIRST_FILTER_SELECTORS.length; i++) {
      var el = sidebar.querySelector(FIRST_FILTER_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function getBlock() {
    return document.querySelector('[data-dp-relcat]');
  }

  function moveEnabled(block) {
    return !!block && block.getAttribute('data-dp-relcat-move') === 'true';
  }

  function place() {
    var block = getBlock();
    if (!moveEnabled(block)) return;

    if (window.innerWidth < DESKTOP) {
      if (block.classList.contains('is-in-sidebar') && block.dpHome) {
        block.dpHome.appendChild(block);
        block.classList.remove('is-in-sidebar');
      }
      return;
    }

    if (block.classList.contains('is-in-sidebar')) return;

    var sidebar = findSidebar();
    if (!sidebar) return;

    if (!block.dpHome) block.dpHome = block.parentNode;

    var firstFilter = findFirstFilter(sidebar);
    if (firstFilter && firstFilter.parentNode) {
      firstFilter.parentNode.insertBefore(block, firstFilter);
    } else {
      sidebar.insertBefore(block, sidebar.firstChild);
    }
    block.classList.add('is-in-sidebar');
  }

  function boot() {
    var block = getBlock();
    if (!moveEnabled(block)) return;

    place();

    /* If the collection sidebar is injected after this section, watch only until it appears.
       This replaces the old 13-pass interval and does no repeated work when moving is disabled. */
    if (!findSidebar() && window.MutationObserver) {
      var observer = new MutationObserver(function () {
        if (!findSidebar()) return;
        place();
        observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(function () { observer.disconnect(); }, 3000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(place, 200);
  });

  document.addEventListener('shopify:section:load', place);
  document.addEventListener('collection:reloaded', place);
  document.addEventListener('filter:updated', place);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lightbox-images"] && !Shopify.designMode) return;
  try {
    
function initCustomLightbox() {
  const images = document.querySelectorAll('.cus_li_collection-item__image');
  
  images.forEach(img => {
    img.addEventListener('click', function() {
      const fullImageUrl = this.getAttribute('data-full');
      if (!fullImageUrl) return;

      // Create Lightbox Background
      const lightbox = document.createElement('div');
      lightbox.id = 'cus-lightbox';
      Object.assign(lightbox.style, {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: '100000',
        cursor: 'zoom-out',
        opacity: '0',
        transition: 'opacity 0.3s ease'
      });

      // Create Image element
      const fullImg = document.createElement('img');
      fullImg.src = fullImageUrl;
      Object.assign(fullImg.style, {
        maxWidth: '90%',
        maxHeight: '90%',
        objectFit: 'contain',
        boxShadow: '0 0 20px rgba(0,0,0,0.5)'
      });

      lightbox.appendChild(fullImg);
      document.body.appendChild(lightbox);

      // Fade in
      setTimeout(() => lightbox.style.opacity = '1', 10);

      // Close on click
      lightbox.addEventListener('click', () => {
        lightbox.style.opacity = '0';
        setTimeout(() => lightbox.remove(), 300);
      });
    });
  });
}

// Initialize on load
document.addEventListener('DOMContentLoaded', initCustomLightbox);

// Re-initialize if inside Shopify Theme Editor (when blocks are added/moved)
document.addEventListener('shopify:section:load', initCustomLightbox);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-cards"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth > 768) return;

  const track = document.querySelector('.t_team_track');
  const slides = document.querySelectorAll('.t_team_slide');
  const prev = document.querySelector('.t_team_prev');
  const next = document.querySelector('.t_team_next');

  let index = 0;

  function updateSlider() {
    track.style.transform = `translateX(-${index * 105}%)`;
  }

  next.addEventListener('click', () => {
    if (index < slides.length - 1) {
      index++;
      updateSlider();
    }
  });

  prev.addEventListener('click', () => {
    if (index > 0) {
      index--;
      updateSlider();
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
